export { RecentProjectsComponent } from '@shared/layout/header/recent-projects/recent-projects.component';
export { RecentProjectsService } from '@shared/layout/header/recent-projects/recent-projects.service';



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/recent-projects/index.ts